import { StoreService } from '../../../../../services/store.service';

export const ConsultaDocumentiFilterComponent = {
  template: require('./consulta-documenti-filter.html'),
  controller: class ConsultaDocumentiFilterComponent {

    static $inject: string[] = [
      '$scope',
      'StoreService'
    ];

    private close: any;
    private dismiss: any;
    private selected: any;

    constructor(
      private $scope: any,
      private storeService: StoreService
    ) {
      $scope.items = [];
      this.selected = $scope.$parent.$resolve.selected;
      $scope.documentTypes = ['Ricevuta Versamento', 'Bonifico eseguito', 'Bonifico Riveuto', 'Estratto conto Bancario', 'Estratto conto Carte Credito'];

      $scope.documentStatuses = [
        { name: '', class: '' },
        { name: 'Da conservare', class: 'label-warning' },
        { name: 'Conservato', class: 'label-success' },
        { name: 'Preso in carico', class: 'label-warning' },
        { name: 'Negativo', class: 'label-danger' },
        { name: 'Da Verificare', class: 'label-info' },
        { name: 'In Queue', class: 'label-warning' },
        { name: 'Worker Error', class: 'label-danger' },
        { name: 'Errore Firma', class: 'label-info' },
        { name: 'Firma in corso', class: 'label-warning' },
        { name: 'Inv. in conservazione', class: 'label-warning' }
      ];

      $scope.notificaTypes = [
        { name: '' },
        { name: 'Consegnata' },
        { name: 'Non ancora consegnata' },
        { name: 'Scartata' },
        { name: 'Accettata' },
        { name: 'Rifiutata' },
        { name: 'Decorsi i termini' },
        { name: 'Non recapitabile' },
        { name: 'Rielaborata' }];

      $scope.monthsStrat = ['', 'Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'];
      $scope.monthsEnd = ['', 'Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'];
      $scope.monthsStratChange = () => {
        $scope.monthsEnd = [];
        for (let i = $scope.settings.filter.meseInizio; i <= 12; i++) {
          $scope.monthsEnd.push($scope.monthsStrat[i]);
        }
        $scope.settings.filter.meseFine = 0;
      };

      $scope.monthsRiferimento = ['', 'Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'];
      $scope.monthsRiferimentoChange = () => {
        for (let i = $scope.settings.filter.meseRiferimento; i <= 12; i++) {
          $scope.monthsRiferimento.push($scope.monthsRiferimento[i]);
        }
        $scope.settings.filter.monthsRiferimento = 0;
      };

      $scope.years = [''];
      let curr_year = new Date().getFullYear();
      for (let i = 2015; i <= curr_year + 5; i++) {
        $scope.years.push(i);
      }

      $scope.settings = $scope.$parent.$resolve.filter;
      $scope.selectedItems = [];
      $scope.specialFilter = {
        'user': this.storeService.getCurrentUser().sub,
        '_id': '',
        'option': ''
      };
      $scope.filterTemp = JSON.parse(JSON.stringify($scope.settings.filter));

      $scope.save = () => {
        $scope.settings.filter = $scope.filterTemp;
        $scope.settings.filter.pageNumber = 1;
        this.close({ $value: $scope.settings });
      };

      $scope.clearFilter = () => {
        $scope.filterTemp._id = '';
        $scope.filterTemp.dataCaricamentoFrom = '';
        $scope.filterTemp.dataCaricamentoTo = '';
        $scope.filterTemp.dataDocumentoFrom = '';
        $scope.filterTemp.dataDocumentoTo = '';
        $scope.filterTemp.dataFatturaFrom = '';
        $scope.filterTemp.dataFatturaTo = '';
        $scope.filterTemp.tipoDocumento = '';
        $scope.filterTemp.fileName = '';
        $scope.filterTemp.meseInizio = '';
        $scope.filterTemp.meseFine = '';
        $scope.filterTemp.meseRiferimento = '';
        $scope.filterTemp.idCodiceRegistro = '';
        $scope.filterTemp.numeroRegistro = '';
        $scope.filterTemp.TipologiaRifiuto = '';
        $scope.filterTemp.stato = '0';
        $scope.filterTemp.periodo = '';
        $scope.filterTemp.denominazione = '';
        $scope.filterTemp.partitaIva = '';
        $scope.filterTemp.codiceFiscale = '';
        $scope.filterTemp.numeroDocumento = '';
        $scope.filterTemp.numeroFattura = '';
        $scope.filterTemp.identificativoSdi = '';
        $scope.filterTemp.tipoNotifica = '';
        $scope.filterTemp.sender = '';
        $scope.filterTemp.primaryRecipient = '';
        $scope.filterTemp.subject = '';
        $scope.filterTemp.receipt = '';
        $scope.filterTemp.anno = '';
        $scope.filterTemp.annoDocumento = '';
        $scope.filterTemp.tipologiaManuale = '';
        $scope.filterTemp.mese = '';
        $scope.filterTemp.oggettoDescrizione = '';
        $scope.filterTemp.annoFiscaleDal = '';
        $scope.filterTemp.annoFiscaleAl = '';
        $scope.filterTemp.annoIva = '';
        $scope.filterTemp.responsabileConservazione = '';
        $scope.filterTemp.numeroProtocollo = '';
        $scope.filterTemp.dataProtocolloFrom = '';
        $scope.filterTemp.dataProtocolloTo = '';
        $scope.filterTemp.annoFattura = '';
        $scope.filterTemp.sezionaleIva = '';
        $scope.filterTemp.codiceIpa = '';
        $scope.filterTemp.codiceUfficio = '';

        $scope.filterTemp.destinatarioNome = '';
        $scope.filterTemp.destinatarioCognome = '';
        $scope.filterTemp.destinatarioRagioneSociale = '';
        $scope.filterTemp.destinatarioPiva = '';
        $scope.filterTemp.destinatarioCodiceFiscale = '';
        $scope.filterTemp.destinatarioDenominazione = '';

        $scope.filterTemp.contribuenteNome = '';
        $scope.filterTemp.contribuenteCognome = '';
        $scope.filterTemp.contribuenteRagioneSociale = '';
        $scope.filterTemp.contribuentePiva = '';
        $scope.filterTemp.contribuenteCodiceFiscale = '';

        $scope.filterTemp.sostitutoimpostaNome = '';
        $scope.filterTemp.sostitutoimpostaCognome = '';
        $scope.filterTemp.sostitutoimpostaRagioneSociale = '';
        $scope.filterTemp.sostitutoimpostaPiva = '';
        $scope.filterTemp.sostitutoimpostaCodiceFiscale = '';

        $scope.filterTemp.numeroOrdine = '';
        $scope.filterTemp.annoOrdineAcquisto = '';
        $scope.filterTemp.dataOrdineFrom = '';
        $scope.filterTemp.dataOrdineTo = '';
        $scope.filterTemp.numeroUnivocoPaziente = '';
        $scope.filterTemp.codiceCartellaClinica = '';
        $scope.filterTemp.dataCreazione = '';
        $scope.filterTemp.dataRegistrazione = '';
        $scope.filterTemp.annoCreazione = '';
        $scope.filterTemp.annoRegistrazione = '';
        $scope.filterTemp.annoDocumento = '';

        $scope.filterTemp.mittenteNome = '';
        $scope.filterTemp.mittenteCognome = '';
        $scope.filterTemp.mittenteRagioneSociale = '';
        $scope.filterTemp.mittentePiva = '';
        $scope.filterTemp.mittenteCodiceFiscale = '';
        $scope.filterTemp.mittenteDenominazione = '';

        $scope.filterTemp.vettoreNome = '';
        $scope.filterTemp.vettoreCognome = '';
        $scope.filterTemp.vettoreRagioneSociale = '';
        $scope.filterTemp.vettorePiva = '';
        $scope.filterTemp.vettoreCodiceFiscale = '';

        $scope.filterTemp.trasportatorePiva = '';
        $scope.filterTemp.trasportatoreCodiceFiscale = '';
        $scope.filterTemp.trasportatoreDenominazione = '';

        $scope.filterTemp.mittentePec = '';
        $scope.filterTemp.destinatarioPec = '';
        $scope.filterTemp.dataPecDa = '';
        $scope.filterTemp.dataPecA = '';
        $scope.filterTemp.oraPec = '';
        $scope.filterTemp.identificativoPec = '';
        $scope.filterTemp.identificativoPecOriginale = '';
        $scope.filterTemp.flussoPec = '';
        $scope.filterTemp.esitoRicevutaPec = '';

        $scope.filterTemp.dataEmailDa = '';
        $scope.filterTemp.dataEmailA = '';
        $scope.filterTemp.flussoEmail = '';        

        $scope.filterTemp.pageNumber = 1;
        $scope.selectedItems = [];
      };

      $scope.updateDateField = (field: string, value: Date) => {
        $scope.filterTemp[field] = value;
      };

      $scope.cancel = () => {
        this.dismiss();
      };

      $scope.hideMeseCondition = () => {
        const classeDocumentale: string = $scope.filterTemp.classeDocumentale;
        const excludeForClasseDocumentale = ['fatture_attive', 'registro_rifiuti', 'certificazione_unica', 'documenti_bancari', 'fattura_elettronica_attiva', 'dichiarazioni_fiscali', 'ricevute_fiscali' ,
          'fattura_elettronica_attiva_notifiche', 'mail_pec', 'modello_dichiarativo', 'altro_documento', 'fattura_passiva', 'formulario_identificativo_rifiuti', 'modello_unico_dichiarazione_ambientale',
          'ddt_attivo', 'ddt_passivo', 'fattura_gse', 'fattura_gse_notifiche', 'lul', 'fattura_elettronica_passiva',
          'fattura_elettronica_passiva_notifiche', 'libro_giornale', 'prima_nota', 'giornali_schede_magazzino', 'libro_inventari', 'registro_omaggi', 'libro_mastro', 'libro_cespiti', 'altri-libri', 'registro-corrispettivi-iva', 'dichiarazioni-fiscali', 'ricevute-fiscali' , 'registro_beni_di_terzi', 'registro-unico-iva',
          'libro_registri_iva', 'registro_riepilogativo_iva', 'altri_registri', 'cm', 'cmr', 'pod',
          'registro_fatture_acquisto', 'registro_corrispettivi_iva', 'registro_beni_di_terzi', 'registro_unico_iva', 'registro_fatture_vendita', 'notifiche_sdi', 'modello_770', 'modello_f23_f24',
          'schede_cliniche', 'ordini_a_fornitore', 'ordini_da_cliente', 'contratti_a_cliente', 'contratti_da_fornitore',
          'manuali', 'bilanci', 'pec_posta_elettronica_certificata', 'corrispondenza_ordinaria' , 'verbali_verifica_scarto', 'nomine_deleghe_conservazione', 'pec_notifiche_pec'];

        return excludeForClasseDocumentale.includes(classeDocumentale);
      };

      /*$scope.showMeseRiferimentoCondition = () => {
        return $scope.filterTemp.classeDocumentale !== 'registro_rifiuti'
          && $scope.filterTemp.classeDocumentale !== 'fir'
        return $scope.filterTemp.classeDocumentale === 'registro_rifiuti' && $scope.filterTemp.classeDocumentale === 'fir'
          ;
      }; */

      $scope.showPeriodoCondition = () => {
        return $scope.filterTemp.classeDocumentale !== 'mail_pec'
          && $scope.filterTemp.classeDocumentale !== 'lul'
          && $scope.filterTemp.classeDocumentale !== 'prima_nota'
          && $scope.filterTemp.classeDocumentale !== 'giornali_schede_magazzino'
          && $scope.filterTemp.classeDocumentale !== 'registro_omaggi'
          && $scope.filterTemp.classeDocumentale !== 'libro_mastro'
          && $scope.filterTemp.classeDocumentale !== 'altri_libri'
          && $scope.filterTemp.classeDocumentale !== 'altri_registri'
          && $scope.filterTemp.classeDocumentale !== 'modello_f23_f24'
          && $scope.filterTemp.classeDocumentale !== 'modello_770'
          && $scope.filterTemp.classeDocumentale !== 'schede_cliniche'
          && $scope.filterTemp.classeDocumentale !== 'modello_730'
          && $scope.filterTemp.classeDocumentale !== 'cm'
          && $scope.filterTemp.classeDocumentale !== 'cmr'
          && $scope.filterTemp.classeDocumentale !== 'formulario_identificativo_rifiuti'
          && $scope.filterTemp.classeDocumentale !== 'modello_unico_dichiarazione_ambientale'
          && $scope.filterTemp.classeDocumentale !== 'pod'
          && $scope.filterTemp.classeDocumentale !== 'bilanci'
          && $scope.filterTemp.classeDocumentale !== 'certificazione_unica'
          && $scope.filterTemp.classeDocumentale !== 'documenti_bancari'
          && $scope.filterTemp.classeDocumentale !== 'ordini_a_fornitore'
          && $scope.filterTemp.classeDocumentale !== 'ordini_da_cliente'
          && $scope.filterTemp.classeDocumentale !== 'contratti_da_fornitore'
          && $scope.filterTemp.classeDocumentale !== 'contratti_a_cliente'
          && $scope.filterTemp.classeDocumentale !== 'manuali'
          && $scope.filterTemp.classeDocumentale !== 'modello_intrastat'
          && $scope.filterTemp.classeDocumentale !== 'dichiarazioni_fiscali'
          && $scope.filterTemp.classeDocumentale !== 'ricevute_fiscali'
          && $scope.filterTemp.classeDocumentale !== 'pec_posta_elettronica_certificata'
          && $scope.filterTemp.classeDocumentale !== 'dichiarazioni_intento_attive'
          && $scope.filterTemp.classeDocumentale !== 'dichiarazioni_intento_passive'
          && $scope.filterTemp.classeDocumentale !== 'documenti_doganali_emessi'
          && $scope.filterTemp.classeDocumentale !== 'documenti_doganali_ricevuti'
          && $scope.filterTemp.classeDocumentale !== 'registro_corrispettivi_iva'
          && $scope.filterTemp.classeDocumentale !== 'registro_beni_di_terzi'
          && $scope.filterTemp.classeDocumentale !== 'registro_unico_iva'
          && $scope.filterTemp.classeDocumentale !== 'corrispondenza_ordinaria'
          && $scope.filterTemp.classeDocumentale !== 'pec_notifiche_pec'
          ;
      };

      $scope.showOggettoDescrizioneCondition = () => {
        return $scope.filterTemp.classeDocumentale === 'libro_giornale'
          || $scope.filterTemp.classeDocumentale === 'libro_inventari'
          || $scope.filterTemp.classeDocumentale === 'registro_omaggi'
          || $scope.filterTemp.classeDocumentale === 'prima_nota'
          || $scope.filterTemp.classeDocumentale === 'giornali_schede_magazzino'
          || $scope.filterTemp.classeDocumentale === 'libro_mastro'
          || $scope.filterTemp.classeDocumentale === 'libro_cespiti'
          || $scope.filterTemp.classeDocumentale === 'altri_libri'
          || $scope.filterTemp.classeDocumentale === 'dichiarazioni_fiscali'
          || $scope.filterTemp.classeDocumentale === 'ricevute_fiscali'
          || $scope.filterTemp.classeDocumentale === 'libro_registri_iva'
          || $scope.filterTemp.classeDocumentale === 'registro_riepilogativo_iva'
          || $scope.filterTemp.classeDocumentale === 'registro_liquidazioni_iva'
          || $scope.filterTemp.classeDocumentale === 'altri_registri'
          || $scope.filterTemp.classeDocumentale === 'registro_fatture_acquisto'
          || $scope.filterTemp.classeDocumentale === 'registro_fatture_vendita'
          || $scope.filterTemp.classeDocumentale === 'altro_documento'
          || $scope.filterTemp.classeDocumentale === 'modello_f23_f24'
          || $scope.filterTemp.classeDocumentale === 'modello_770'
          || $scope.filterTemp.classeDocumentale === 'schede_cliniche'
          || $scope.filterTemp.classeDocumentale === 'ordini_a_fornitore'
          || $scope.filterTemp.classeDocumentale === 'ordini_da_cliente'
          || $scope.filterTemp.classeDocumentale === 'contratti_da_fornitore'
          || $scope.filterTemp.classeDocumentale === 'contratti_a_cliente'
          || $scope.filterTemp.classeDocumentale === 'modello_730'
          || $scope.filterTemp.classeDocumentale === 'bilanci'
          || $scope.filterTemp.classeDocumentale === 'lul'
          || $scope.filterTemp.classeDocumentale === 'certificazione_unica'
          || $scope.filterTemp.classeDocumentale === 'documenti_bancari'
          || $scope.filterTemp.classeDocumentale === 'cm'
          || $scope.filterTemp.classeDocumentale === 'cmr'
          || $scope.filterTemp.classeDocumentale === 'formulario_identificativo_rifiuti'
          || $scope.filterTemp.classeDocumentale === 'modello_unico_dichiarazione_ambientale'
          || $scope.filterTemp.classeDocumentale === 'pod'
          || $scope.filterTemp.classeDocumentale === 'manuali'
          || $scope.filterTemp.classeDocumentale === 'modello_intrastat'
          || $scope.filterTemp.classeDocumentale === 'libri_sociali'
          || $scope.filterTemp.classeDocumentale === 'registro-liquidazioni-iva'
          || $scope.filterTemp.classeDocumentale === 'pec_posta_elettronica_certificata'
          || $scope.filterTemp.classeDocumentale === 'verbali_verifica_scarto'
          || $scope.filterTemp.classeDocumentale === 'nomine_deleghe_conservazione'
          || $scope.filterTemp.classeDocumentale === 'registro_unico_iva'
          || $scope.filterTemp.classeDocumentale === 'registro_beni_di_terzi'
          || $scope.filterTemp.classeDocumentale === 'corrispondenza_ordinaria'
          || $scope.filterTemp.classeDocumentale === 'pec_notifiche_pec'
          ;
      };

      $scope.showDestinatarioCondition = () => {
        return $scope.filterTemp.classeDocumentale === 'modello_f23_f24'
          || $scope.filterTemp.classeDocumentale === 'modello_770'
          || $scope.filterTemp.classeDocumentale === 'schede_cliniche'
          || $scope.filterTemp.classeDocumentale === 'modello_730'
          || $scope.filterTemp.classeDocumentale === 'cmr'
          || $scope.filterTemp.classeDocumentale === 'pod'
          || $scope.filterTemp.classeDocumentale === 'ordini_da_cliente'
          || $scope.filterTemp.classeDocumentale === 'contratti_a_cliente'
          || $scope.filterTemp.classeDocumentale === 'dichiarazioni_intento_attive'
          || $scope.filterTemp.classeDocumentale === 'dichiarazioni_intento_passive'
          || $scope.filterTemp.classeDocumentale === 'bilanci'
          ;
      };

      /* inizio */
      $scope.showContribuenteNome = () => {
        return $scope.filterTemp.classeDocumentale === 'certificazione_unica'
          ;
      };

      $scope.showContribuenteCognome = () => {
        return $scope.filterTemp.classeDocumentale === 'certificazione_unica'
          ;
      };

      $scope.showAnnoDocumento = () => {
        return $scope.filterTemp.classeDocumentale === 'manuali'
          || $scope.filterTemp.classeDocumentale === 'cmr'
          || $scope.filterTemp.classeDocumentale === 'modello_intrastat'
          || $scope.filterTemp.classeDocumentale === 'schede_cliniche'
          || $scope.filterTemp.classeDocumentale === 'dichiarazioni_intento_attive'
          || $scope.filterTemp.classeDocumentale === 'dichiarazioni_intento_passive'
          || $scope.filterTemp.classeDocumentale === 'documenti_doganali_emessi'
          || $scope.filterTemp.classeDocumentale === 'documenti_doganali_ricevuti'
          || $scope.filterTemp.classeDocumentale === 'pod'
          ;
      };

      $scope.showMeseRiferimento = () => {
        return $scope.filterTemp.classeDocumentale === 'registro_rifiuti'
          || $scope.filterTemp.classeDocumentale === 'formulario_identificativo_rifiuti'
          ;
      };

      $scope.showTipologiaManuale = () => {
        return $scope.filterTemp.classeDocumentale === 'manuali'
          ;
      };

      /* fine */

      $scope.showContribuentePIVACondition = () => {
        return $scope.filterTemp.classeDocumentale === 'certificazione_unica'
          ;
      };

      $scope.showNomeCognomeCodiceFiscaleDestinatarioCondition = () => {
        return $scope.filterTemp.classeDocumentale === 'modello_f23_f24'
          || $scope.filterTemp.classeDocumentale === 'modello_770'
          || $scope.filterTemp.classeDocumentale === 'schede_cliniche'
          || $scope.filterTemp.classeDocumentale === 'modello_730'
          || $scope.filterTemp.classeDocumentale === 'bilanci'
          || $scope.filterTemp.classeDocumentale === 'cmr'
          || $scope.filterTemp.classeDocumentale === 'documenti_bancari'
          || $scope.filterTemp.classeDocumentale === 'pod'
          || $scope.filterTemp.classeDocumentale === 'ordini_da_cliente'
          || $scope.filterTemp.classeDocumentale === 'contratti_a_cliente'
          || $scope.filterTemp.classeDocumentale === 'dichiarazioni_intento_attive'
          || $scope.filterTemp.classeDocumentale === 'dichiarazioni_intento_passive'
          || $scope.filterTemp.classeDocumentale === 'lul'
          ;
      };

      $scope.showContribuenteCondition = () => {
        return $scope.filterTemp.classeDocumentale === 'modello_f23_f24'
          || $scope.filterTemp.classeDocumentale === 'certificazione_unica'
          ;
      };

      $scope.showMittenteCondition = () => {
        return $scope.filterTemp.classeDocumentale === 'cmr'
          || $scope.filterTemp.classeDocumentale === 'pod'
          || $scope.filterTemp.classeDocumentale === 'ordini_a_fornitore'
          || $scope.filterTemp.classeDocumentale === 'contratti_da_fornitore'
          || $scope.filterTemp.classeDocumentale === 'schede_cliniche'
          || $scope.filterTemp.classeDocumentale === 'ricevute_fiscali'
          || $scope.filterTemp.classeDocumentale === 'documenti_doganali_ricevuti'
          || $scope.filterTemp.classeDocumentale === 'documenti_bancari'
          ;
      };

      //$scope.showMittentePack = () => {
      //  return $scope.filterTemp.classeDocumentale === 'fir'
      //    ;
      //};

      $scope.showDestinatarioPack = () => {
        return $scope.filterTemp.classeDocumentale === 'formulario_identificativo_rifiuti'
          || $scope.filterTemp.classeDocumentale === 'note_spese_e_trasferte'
          || $scope.filterTemp.classeDocumentale === 'registro_corrispettivi_iva'
          || $scope.filterTemp.classeDocumentale === 'dichiarazioni_fiscali'
          || $scope.filterTemp.classeDocumentale === 'libri_sociali'
          ;
      };

      $scope.showTrasportatorePack = () => {
        return $scope.filterTemp.classeDocumentale === 'formulario_identificativo_rifiuti'
          || $scope.filterTemp.classeDocumentale === 'modello_unico_dichiarazione_ambientale'
          ;
      };

      $scope.showRegistroCondition = () => {
        return $scope.filterTemp.classeDocumentale === 'formulario_identificativo_rifiuti'
          ;
      };

      $scope.showVettoreCondition = () => {
        return $scope.filterTemp.classeDocumentale === 'cmr'
          || $scope.filterTemp.classeDocumentale === 'cm'
          || $scope.filterTemp.classeDocumentale === 'pod'
          ;
      };

      $scope.showSostitutoImpostaCondition = () => {
        return $scope.filterTemp.classeDocumentale === 'modello_770'
          || $scope.filterTemp.classeDocumentale === 'modello_730'
          ;
      };

      $scope.showPazienteCondition = () => {
        return $scope.filterTemp.classeDocumentale === 'schede_cliniche'
          ;
      };

      $scope.showAnnoFiscaleDalCondition = () => {
        return $scope.filterTemp.classeDocumentale === 'libro_giornale'
          || $scope.filterTemp.classeDocumentale === 'modello_intrastat'
          || $scope.filterTemp.classeDocumentale === 'libri_sociali'
          || $scope.filterTemp.classeDocumentale === 'libro_inventari'
          || $scope.filterTemp.classeDocumentale === 'registro_omaggi'
          || $scope.filterTemp.classeDocumentale === 'prima_nota'
          || $scope.filterTemp.classeDocumentale === 'giornali_schede_magazzino'
          || $scope.filterTemp.classeDocumentale === 'libro_mastro'
          || $scope.filterTemp.classeDocumentale === 'libro_cespiti'
          || $scope.filterTemp.classeDocumentale === 'altri_libri'
          || $scope.filterTemp.classeDocumentale === 'dichiarazioni_fiscali'
          || $scope.filterTemp.classeDocumentale === 'ricevute_fiscali'
          || $scope.filterTemp.classeDocumentale === 'libro_registri_iva'
          || $scope.filterTemp.classeDocumentale === 'registro_riepilogativo_iva'
          || $scope.filterTemp.classeDocumentale === 'altri_registri'
          || $scope.filterTemp.classeDocumentale === 'registro_fatture_acquisto'
          || $scope.filterTemp.classeDocumentale === 'registro_fatture_vendita'
          || $scope.filterTemp.classeDocumentale === 'registro_liquidazioni_iva'
          || $scope.filterTemp.classeDocumentale === 'altro_documento'
          || $scope.filterTemp.classeDocumentale === 'modello_f23_f24'
          || $scope.filterTemp.classeDocumentale === 'modello_770'
          || $scope.filterTemp.classeDocumentale === 'modello_730'
          || $scope.filterTemp.classeDocumentale === 'contratti_da_fornitore'
          || $scope.filterTemp.classeDocumentale === 'contratti_a_cliente'
          || $scope.filterTemp.classeDocumentale === 'verbali_verifica_scarto'
          || $scope.filterTemp.classeDocumentale === 'nomine_deleghe_conservazione'
          || $scope.filterTemp.classeDocumentale === 'registro_corrispettivi_iva'
          || $scope.filterTemp.classeDocumentale === 'registro_beni_di_terzi'
          || $scope.filterTemp.classeDocumentale === 'registro_unico_iva'
          || $scope.filterTemp.classeDocumentale === 'bilanci'
          ;
      };

      // manuali
      $scope.showAnnoDocumentoCondition = () => {
        return $scope.filterTemp.classeDocumentale === 'manuali'
          || $scope.filterTemp.classeDocumentale === 'cmr'
          || $scope.filterTemp.classeDocumentale === 'modello_intrastat'
          || $scope.filterTemp.classeDocumentale === 'schede_cliniche'
          || $scope.filterTemp.classeDocumentale === 'pod'
          ;
      };

      $scope.showMeseRiferimentoCondition = () => {
        return $scope.filterTemp.classeDocumentale === 'registro_rifiuti'
          || $scope.filterTemp.classeDocumentale === 'formulario_identificativo_rifiuti'
          ;
      };

      $scope.showTipologiaManualeCondition = () => {
        return $scope.filterTemp.classeDocumentale === 'manuali'
          ;
      };
      //

      $scope.showAnnoFiscaleAlCondition = () => {
        return $scope.filterTemp.classeDocumentale === 'libro_giornale'
          || $scope.filterTemp.classeDocumentale === 'modello_intrastat'
          || $scope.filterTemp.classeDocumentale === 'libri_sociali'
          || $scope.filterTemp.classeDocumentale === 'registro_liquidazioni_iva'
          || $scope.filterTemp.classeDocumentale === 'libro_inventari'
          || $scope.filterTemp.classeDocumentale === 'dichiarazioni_fiscali'
          || $scope.filterTemp.classeDocumentale === 'ricevute_fiscali'
          || $scope.filterTemp.classeDocumentale === 'registro_omaggi'
          || $scope.filterTemp.classeDocumentale === 'prima_nota'
          || $scope.filterTemp.classeDocumentale === 'giornali_schede_magazzino'
          || $scope.filterTemp.classeDocumentale === 'libro_mastro'
          || $scope.filterTemp.classeDocumentale === 'libro_cespiti'
          || $scope.filterTemp.classeDocumentale === 'altri_libri'
          || $scope.filterTemp.classeDocumentale === 'libro_registri_iva'
          || $scope.filterTemp.classeDocumentale === 'registro_riepilogativo_iva'
          || $scope.filterTemp.classeDocumentale === 'altri_registri'
          || $scope.filterTemp.classeDocumentale === 'registro_fatture_acquisto'
          || $scope.filterTemp.classeDocumentale === 'registro_fatture_vendita'
          || $scope.filterTemp.classeDocumentale === 'altro_documento'
          || $scope.filterTemp.classeDocumentale === 'modello_f23_f24'
          || $scope.filterTemp.classeDocumentale === 'documenti_bancari'
          || $scope.filterTemp.classeDocumentale === 'modello_770'
          || $scope.filterTemp.classeDocumentale === 'modello_730'
          || $scope.filterTemp.classeDocumentale === 'contratti_da_fornitore'
          || $scope.filterTemp.classeDocumentale === 'contratti_a_cliente'
          || $scope.filterTemp.classeDocumentale === 'verbali_verifica_scarto'
          || $scope.filterTemp.classeDocumentale === 'nomine_deleghe_conservazione'
          || $scope.filterTemp.classeDocumentale === 'registro_corrispettivi_iva'
          || $scope.filterTemp.classeDocumentale === 'registro_beni_di_terzi'
          || $scope.filterTemp.classeDocumentale === 'registro_unico_iva'
          || $scope.filterTemp.classeDocumentale === 'bilanci'
          ;
      };

      $scope.showAnnoIvaCondition = () => {
        return $scope.filterTemp.classeDocumentale === 'ddt_attivo'
          || $scope.filterTemp.classeDocumentale === 'ddt_passivo'
          || $scope.filterTemp.classeDocumentale === 'modello_intrastat'
          || $scope.filterTemp.classeDocumentale === 'libri_sociali'
          || $scope.filterTemp.classeDocumentale === 'registro_liquidazioni_iva'
          || $scope.filterTemp.classeDocumentale === 'libro_registri_iva'
          || $scope.filterTemp.classeDocumentale === 'ordini_a_fornitore'
          || $scope.filterTemp.classeDocumentale === 'ordini_da_cliente'
          || $scope.filterTemp.classeDocumentale === 'dichiarazioni_fiscali'
          || $scope.filterTemp.classeDocumentale === 'ricevute_fiscali'
          || $scope.filterTemp.classeDocumentale === 'contratti_da_fornitore'
          || $scope.filterTemp.classeDocumentale === 'contratti_a_cliente'
          || $scope.filterTemp.classeDocumentale === 'registro_riepilogativo_iva'
          || $scope.filterTemp.classeDocumentale === 'altri_registri'
          || $scope.filterTemp.classeDocumentale === 'altri_libri'
          || $scope.filterTemp.classeDocumentale === 'registro_fatture_acquisto'
          || $scope.filterTemp.classeDocumentale === 'registro_fatture_vendita'
          || $scope.filterTemp.classeDocumentale === 'certificazione_unica'
          || $scope.filterTemp.classeDocumentale === 'cmr'
          || $scope.filterTemp.classeDocumentale === 'formulario_identificativo_rifiuti'
          || $scope.filterTemp.classeDocumentale === 'modello_unico_dichiarazione_ambientale'
          || $scope.filterTemp.classeDocumentale === 'pod'
          || $scope.filterTemp.classeDocumentale === 'registro_rifiuti'
          || $scope.filterTemp.classeDocumentale === 'modello_770'
          || $scope.filterTemp.classeDocumentale === 'dichiarazioni_intento_attive'
          || $scope.filterTemp.classeDocumentale === 'dichiarazioni_intento_passive'
          || $scope.filterTemp.classeDocumentale === 'documenti_doganali_emessi'
          || $scope.filterTemp.classeDocumentale === 'note_spese_e_trasferte'
          || $scope.filterTemp.classeDocumentale === 'registro_corrispettivi_iva'
          || $scope.filterTemp.classeDocumentale === 'registro_unico_iva'
          || $scope.filterTemp.classeDocumentale === 'modello_730'
          ;
      };

      $scope.showResponsabileConservazioneCondition = () => {
        return $scope.filterTemp.classeDocumentale === 'libro_giornale'
          || $scope.filterTemp.classeDocumentale === 'libro_inventari'
          || $scope.filterTemp.classeDocumentale === 'registro_omaggi'
          || $scope.filterTemp.classeDocumentale === 'prima_nota'
          || $scope.filterTemp.classeDocumentale === 'giornali_schede_magazzino'
          || $scope.filterTemp.classeDocumentale === 'libro_mastro'
          || $scope.filterTemp.classeDocumentale === 'libro_cespiti'
          || $scope.filterTemp.classeDocumentale === 'altri_libri'
          || $scope.filterTemp.classeDocumentale === 'libro_registri_iva'
          || $scope.filterTemp.classeDocumentale === 'registro_riepilogativo_iva'
          || $scope.filterTemp.classeDocumentale === 'altri_registri'
          || $scope.filterTemp.classeDocumentale === 'registro_fatture_acquisto'
          || $scope.filterTemp.classeDocumentale === 'registro_fatture_vendita'
          ;
      };

      $scope.showNumeroProtocolloCondition = () => {
        return $scope.filterTemp.classeDocumentale === 'ddt_passivo'
          || $scope.filterTemp.classeDocumentale === 'fattura_passiva'
          || $scope.filterTemp.classeDocumentale === 'modello_intrastat'
          || $scope.filterTemp.classeDocumentale === 'libri_sociali'
          ;
      };

      $scope.showDataProtocolloCondition = () => {
        return $scope.filterTemp.classeDocumentale === 'ddt_passivo'
          || $scope.filterTemp.classeDocumentale === 'fattura_passiva'
          || $scope.filterTemp.classeDocumentale === 'modello_intrastat'
          || $scope.filterTemp.classeDocumentale === 'libri_sociali'
          ;
      };

      $scope.showAnnoFatturaCondition = () => {
        const classeDocumentale: string = $scope.filterTemp.classeDocumentale;
        const showForClasseDocumentale = ['fatture_attive', 'fattura_passiva', 'notifiche_sdi'];
        return showForClasseDocumentale.includes(classeDocumentale);
      };

      $scope.showSezionaleIvaCondition = () => {
        return $scope.filterTemp.classeDocumentale === 'fatture_attive'
          || $scope.filterTemp.classeDocumentale === 'fattura_passiva'
          ;
      };

      $scope.showCodiceIpaCondition = () => {
        return $scope.filterTemp.classeDocumentale === 'fatture_attive'
          || $scope.filterTemp.classeDocumentale === 'fattura_passiva'
          || $scope.filterTemp.classeDocumentale === 'ddt_attivo'
          || $scope.filterTemp.classeDocumentale === 'ddt_passivo'
          ;
      };

      $scope.showCodiceUfficioCondition = () => {
        return $scope.filterTemp.classeDocumentale === 'fatture_attive'
          || $scope.filterTemp.classeDocumentale === 'fattura_passiva'
          || $scope.filterTemp.classeDocumentale === 'ddt_attivo'
          || $scope.filterTemp.classeDocumentale === 'ddt_passivo'
          ;
      };

      $scope.showDenominazioneCondition = () => {
        const classeDocumentale: string = $scope.filterTemp.classeDocumentale;
        const showForClasseDocumentale = ['fatture_attive', 'fattura_elettronica_attiva',
          'fattura_elettronica_attiva_notifiche', 'contratti_da_fornitore', 'contratti_a_cliente', 'fattura_passiva',
          'ddt_attivo', 'ddt_passivo', 'fattura_gse_notifiche', 'fattura_gse', 'fattura_elettronica_passiva',
          'fattura_elettronica_passiva_notifiche', 'notifiche_sdi'];
        return showForClasseDocumentale.includes(classeDocumentale);
      };

      $scope.showNumeroDocumento = () => {
        return $scope.filterTemp.classeDocumentale === 'fatture_attive' || $scope.filterTemp.classeDocumentale === 'fattura_elettronica_attiva'
          || $scope.filterTemp.classeDocumentale === 'fattura_elettronica_attiva_notifiche' || $scope.filterTemp.classeDocumentale === 'bollette'
          || $scope.filterTemp.classeDocumentale === 'fattura_passiva' || $scope.filterTemp.classeDocumentale === 'ddt_attivo'
          || $scope.filterTemp.classeDocumentale === 'ddt_passivo' || $scope.filterTemp.classeDocumentale === 'fattura_gse'
          || $scope.filterTemp.classeDocumentale === 'fattura_gse_notifiche' || $scope.filterTemp.classeDocumentale === 'fattura_elettronica_passiva'
          || $scope.filterTemp.classeDocumentale === 'fattura_elettronica_passiva_notifiche' || $scope.filterTemp.classeDocumentale === 'manuali' || $scope.filterTemp.classeDocumentale === 'intrastat'
          || $scope.filterTemp.classeDocumentale === 'documenti_bancari' || $scope.filterTemp.classeDocumentale === 'cm' || $scope.filterTemp.classeDocumentale === 'note_spese_e_trasferte'
          || $scope.filterTemp.classeDocumentale === 'cmr' || $scope.filterTemp.classeDocumentale === 'contratti_da_fornitore' || $scope.filterTemp.classeDocumentale === 'modello_unico_dichiarazione_ambientale'
          || $scope.filterTemp.classeDocumentale === 'ordini_a_fornitore' || $scope.filterTemp.classeDocumentale === 'ordini_da_cliente' || $scope.filterTemp.classeDocumentale === 'dichiarazioni_intento_attive' || $scope.filterTemp.classeDocumentale === 'documenti_doganali_emessi' || $scope.filterTemp.classeDocumentale === 'documenti_doganali_ricevuti' || $scope.filterTemp.classeDocumentale === 'dichiarazioni_intento_passive'
          || $scope.filterTemp.classeDocumentale === 'contratti_a_cliente' || $scope.filterTemp.classeDocumentale === 'pod';
      };
      $scope.showProgressivoInvio = () => {
        return $scope.filterTemp.classeDocumentale === 'fattura_elettronica_attiva' || $scope.filterTemp.classeDocumentale === 'fattura_elettronica_attiva_notifiche'
          || $scope.filterTemp.classeDocumentale === 'fattura_gse_notifiche' || $scope.filterTemp.classeDocumentale === 'fattura_gse'
          || $scope.filterTemp.classeDocumentale === 'fattura_elettronica_passiva'
          || $scope.filterTemp.classeDocumentale === 'fattura_elettronica_passiva_notifiche';
      };
      $scope.showTipoDocumento = () => {
        const classeDocumentale: string = $scope.filterTemp.classeDocumentale;
        const excludeForClasseDocumentale = ['mail_pec', 'ddt_attivo', 'contratti_da_fornitore',
          'ordini_a_fornitore', 'ordini_da_cliente', 'contratti_a_cliente', 'ddt_passivo', 'lul', 'libro_giornale', 'altri_libri', 'giornali_schede_magazzino',
          'notifiche_sdi', 'modello_770', 'modello_730', 'corrispondenza_ordinaria' , 'modello_f23_f24', 'bilanci', 'manuali', 'certificazione_unica', 'dichiarazioni_fiscali', 'ricevute_fiscali' ,
          'cm', 'cmr', 'pod', 'schede_cliniche', 'registro_unico_iva', 'registro_beni_di_terzi', 'documenti_bancari'];
        return !excludeForClasseDocumentale.includes(classeDocumentale);
      };
      $scope.showTipoDocumentoBancario = () => {
        return $scope.filterTemp.classeDocumentale === 'documenti_bancari';
      };
      $scope.showDataDocumento = () => {
        const classeDocumentale: string = $scope.filterTemp.classeDocumentale;
        const excludeForClasseDocumentale = ['notifiche_sdi', 'modello_730', 'schede_cliniche', 'modello_770', 'formulario_identificativo_rifiuti', 'dichiarazioni_fiscali', 'ricevute_fiscali' ,
          'pec_posta_elettronica_certificata', 'altri_libri', 'registro_liquidazioni_iva', 'registro_corrispettivi_iva', 'registro_beni_di_terzi', 'corrispondenza_ordinaria' , 'pec_notifiche_pec'];
        return !excludeForClasseDocumentale.includes(classeDocumentale);
      };
      $scope.showDataCaricamento = () => {
        const classeDocumentale: string = $scope.filterTemp.classeDocumentale;
        const includeForClasseDocumentale = ['modello_770', 'modello_730'];
        return includeForClasseDocumentale.includes(classeDocumentale);
      };
      $scope.showIdentificativoSdi = () => {
        const classeDocumentale: string = $scope.filterTemp.classeDocumentale;
        const showForClasseDocumentale = ['notifiche_sdi'];
        return showForClasseDocumentale.includes(classeDocumentale);
      };
      $scope.showTipoNotifica = () => {
        const classeDocumentale: string = $scope.filterTemp.classeDocumentale;
        const showForClasseDocumentale = ['notifiche_sdi'];
        return showForClasseDocumentale.includes(classeDocumentale);
      };
      $scope.showNumeroFattura = () => {
        const classeDocumentale: string = $scope.filterTemp.classeDocumentale;
        const showForClasseDocumentale = ['notifiche_sdi'];
        return showForClasseDocumentale.includes(classeDocumentale);
      };
      $scope.showDataFattura = () => {
        const classeDocumentale: string = $scope.filterTemp.classeDocumentale;
        const showForClasseDocumentale = ['notifiche_sdi'];
        return showForClasseDocumentale.includes(classeDocumentale);
      };
      $scope.showDataFattura = () => {
        const classeDocumentale: string = $scope.filterTemp.classeDocumentale;
        const showForClasseDocumentale = ['notifiche_sdi'];
        return showForClasseDocumentale.includes(classeDocumentale);
      };
      $scope.showFileNameFattura = () => {
        const classeDocumentale: string = $scope.filterTemp.classeDocumentale;
        const showForClasseDocumentale = ['notifiche_sdi'];
        return showForClasseDocumentale.includes(classeDocumentale);
      };

      $scope.showMittentePec = () => {
        const classeDocumentale: string = $scope.filterTemp.classeDocumentale;
        const showForClasseDocumentale = ['pec_posta_elettronica_certificata', 'pec_notifiche_pec'];
        return showForClasseDocumentale.includes(classeDocumentale);
      };
      $scope.showDestinatarioPec = () => {
        const classeDocumentale: string = $scope.filterTemp.classeDocumentale;
        const showForClasseDocumentale = ['pec_posta_elettronica_certificata', 'pec_notifiche_pec'];
        return showForClasseDocumentale.includes(classeDocumentale);
      };
      $scope.showDataPec = () => {
        const classeDocumentale: string = $scope.filterTemp.classeDocumentale;
        const showForClasseDocumentale = ['pec_posta_elettronica_certificata', 'pec_notifiche_pec'];
        return showForClasseDocumentale.includes(classeDocumentale);
      };
      //
      $scope.showDataEmail = () => {
        const classeDocumentale: string = $scope.filterTemp.classeDocumentale;
        const showForClasseDocumentale = ['corrispondenza_ordinaria'];
        return showForClasseDocumentale.includes(classeDocumentale);
      };
      //
      $scope.showOraPec = () => {
        const classeDocumentale: string = $scope.filterTemp.classeDocumentale;
        const showForClasseDocumentale = ['pec_posta_elettronica_certificata', 'pec_notifiche_pec'];
        return showForClasseDocumentale.includes(classeDocumentale);
      };
      $scope.showIdentificativoPec = () => {
        const classeDocumentale: string = $scope.filterTemp.classeDocumentale;
        const showForClasseDocumentale = ['pec_posta_elettronica_certificata', 'pec_notifiche_pec'];
        return showForClasseDocumentale.includes(classeDocumentale);
      };
      $scope.showIdentificativoPecOriginale = () => {
        const classeDocumentale: string = $scope.filterTemp.classeDocumentale;
        const showForClasseDocumentale = ['pec_posta_elettronica_certificata', 'pec_notifiche_pec'];
        return showForClasseDocumentale.includes(classeDocumentale);
      };
      $scope.showFlussoPec = () => {
        const classeDocumentale: string = $scope.filterTemp.classeDocumentale;
        const showForClasseDocumentale = ['pec_posta_elettronica_certificata', 'pec_notifiche_pec'];
        return showForClasseDocumentale.includes(classeDocumentale);
      };
      //
      $scope.showFlussoEmail = () => {
        const classeDocumentale: string = $scope.filterTemp.classeDocumentale;
        const showForClasseDocumentale = ['corrispondenza_ordinaria'];
        return showForClasseDocumentale.includes(classeDocumentale);
      };
      //
      $scope.showEsitoNotificaPec = () => {
        const classeDocumentale: string = $scope.filterTemp.classeDocumentale;
        const showForClasseDocumentale = ['pec_notifiche_pec'];
        return showForClasseDocumentale.includes(classeDocumentale);
      };
    }
  },
  bindings: {
    close: '&',
    dismiss: '&'
  }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/consulta-documenti-filter/consulta-documenti-filter.ts